import React, { useState } from 'react';
import SpecialistAccountModal from '../../components/SpecialistAccountModal';
import Pagination from '../../components/Pagination/Pagination';
import './SpecialistManagePage.css';

const SpecialistManagePage = () => {
  const [selectedSpecialists, setSelectedSpecialists] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('All Status');
  const [categoryFilter, setCategoryFilter] = useState('All Categories');
  const [selectedSpecialist, setSelectedSpecialist] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const ITEMS_PER_PAGE = 10;

  const specialistData = [
    { 
      id: 1, 
      date: '01,21,2023', 
      name: 'Engr. Jerome Bell', 
      title: 'Architecture Engineer',
      category: 'Building Materials', 
      expertise: 'Office Architecture, Home Architect',
      location: 'United Kingdom', 
      email: 'jerome@company.com', 
      status: 'Pending',
      avatar: '/uploads/builder-images/a1716e9d491755ccb3db0cc5acd0c6e28adaa549.jpg',
      interestedLocations: 'USA, Canada, Sadia Arab, Dubai, Katar, Bangladesh, India',
      experience: '12 years'
    },
    { 
      id: 2, 
      date: '01,21,2023', 
      name: 'Dr. Sarah Johnson', 
      title: 'Civil Engineer',
      category: 'Construction', 
      expertise: 'Structural Design, Project Management',
      location: 'Dubai', 
      email: 'sarah@company.com', 
      status: 'Approved',
      avatar: '/uploads/builder-images/a1716e9d491755ccb3db0cc5acd0c6e28adaa549.jpg',
      interestedLocations: 'UAE, Saudi Arabia, Qatar',
      experience: '8 years'
    },
    { 
      id: 3, 
      date: '01,20,2023', 
      name: 'Ahmed Al-Rashid', 
      title: 'Interior Designer',
      category: 'Interior Design', 
      expertise: 'Residential, Commercial Spaces',
      location: 'Saudi Arabia', 
      email: 'ahmed@company.com', 
      status: 'Pending',
      avatar: '/uploads/builder-images/a1716e9d491755ccb3db0cc5acd0c6e28adaa549.jpg',
      interestedLocations: 'GCC Countries',
      experience: '15 years'
    },
    { 
      id: 4, 
      date: '01,19,2023', 
      name: 'Maria Santos', 
      title: 'Landscape Architect',
      category: 'Landscaping', 
      expertise: 'Urban Planning, Garden Design',
      location: 'Qatar', 
      email: 'maria@company.com', 
      status: 'Approved',
      avatar: '/uploads/builder-images/a1716e9d491755ccb3db0cc5acd0c6e28adaa549.jpg',
      interestedLocations: 'Middle East, Europe',
      experience: '10 years'
    },
    { 
      id: 5, 
      date: '01,18,2023', 
      name: 'John Smith', 
      title: 'MEP Engineer',
      category: 'MEP Services', 
      expertise: 'HVAC, Electrical Systems',
      location: 'Kuwait', 
      email: 'john@company.com', 
      status: 'Rejected',
      avatar: '/uploads/builder-images/a1716e9d491755ccb3db0cc5acd0c6e28adaa549.jpg',
      interestedLocations: 'Kuwait, Bahrain, UAE',
      experience: '6 years'
    },
    { 
      id: 6, 
      date: '01,17,2023', 
      name: 'Fatima Al-Hassan', 
      title: 'Project Manager',
      category: 'Project Management', 
      expertise: 'Construction Management, Cost Control',
      location: 'Bahrain', 
      email: 'fatima@company.com', 
      status: 'Pending',
      avatar: '/uploads/builder-images/a1716e9d491755ccb3db0cc5acd0c6e28adaa549.jpg',
      interestedLocations: 'GCC, North Africa',
      experience: '20 years'
    },
  ];

  const sidebarMenuItems = [
    { id: 'dashboard', icon: 'home', label: 'Dashboard', active: false },
    { id: 'specialists', icon: 'users', label: 'Specialists Manage', active: true, hasSubmenu: true },
    { id: 'suppliers', icon: 'building', label: 'Suppliers Manage', active: false, hasSubmenu: true },
    { id: 'products', icon: 'list', label: 'Products Manage', active: false, hasSubmenu: true },
    { id: 'projects', icon: 'folder', label: 'Projects Manage', active: false, hasSubmenu: true },
    { id: 'messages', icon: 'chat', label: 'Messages', active: false, hasSubmenu: true },
    { id: 'settings', icon: 'settings', label: 'Settings', active: false },
  ];

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedSpecialists(specialistData.map(s => s.id));
    } else {
      setSelectedSpecialists([]);
    }
  };

  const handleSelectSpecialist = (specialistId) => {
    if (selectedSpecialists.includes(specialistId)) {
      setSelectedSpecialists(selectedSpecialists.filter(id => id !== specialistId));
    } else {
      setSelectedSpecialists([...selectedSpecialists, specialistId]);
    }
  };

  const handleViewDetails = (specialist) => {
    setSelectedSpecialist(specialist);
    setIsModalOpen(true);
  };

  const handleApprove = (specialist) => {
    console.log('Approved specialist:', specialist);
    setIsModalOpen(false);
    // Here you would typically make an API call to update the specialist status
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedSpecialist(null);
  };

  const renderIcon = (iconName) => {
    switch (iconName) {
      case 'home':
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M9 22V12H15V22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        );
      case 'users':
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        );
      case 'building':
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 21H21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M5 21V7L13 3V21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M19 21V11L13 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M9 9V9.01" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M9 12V12.01" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M9 15V15.01" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M9 18V18.01" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        );
      case 'list':
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M3.25 7C3.25 6.80109 3.32902 6.61032 3.46967 6.46967C3.61032 6.32902 3.80109 6.25 4 6.25H20C20.1989 6.25 20.3897 6.32902 20.5303 6.46967C20.671 6.61032 20.75 6.80109 20.75 7C20.75 7.19891 20.671 7.38968 20.5303 7.53033C20.3897 7.67098 20.1989 7.75 20 7.75H4C3.80109 7.75 3.61032 7.67098 3.46967 7.53033C3.32902 7.38968 3.25 7.19891 3.25 7ZM3.25 12C3.25 11.8011 3.32902 11.6103 3.46967 11.4697C3.61032 11.329 3.80109 11.25 4 11.25H15C15.1989 11.25 15.3897 11.329 15.5303 11.4697C15.671 11.6103 15.75 11.8011 15.75 12C15.75 12.1989 15.671 12.3897 15.5303 12.5303C15.3897 12.671 15.1989 12.75 15 12.75H4C3.80109 12.75 3.61032 12.671 3.46967 12.5303C3.32902 12.3897 3.25 12.1989 3.25 12ZM3.25 17C3.25 16.8011 3.32902 16.6103 3.46967 16.4697C3.61032 16.329 3.80109 16.25 4 16.25H9C9.19891 16.25 9.38968 16.329 9.53033 16.4697C9.67098 16.6103 9.75 16.8011 9.75 17C9.75 17.1989 9.67098 17.3897 9.53033 17.5303C9.38968 17.671 9.19891 17.75 9 17.75H4C3.80109 17.75 3.61032 17.671 3.46967 17.5303C3.32902 17.3897 3.25 17.1989 3.25 17Z" fill="currentColor"/>
          </svg>
        );
      case 'folder':
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22 19C22 19.5304 21.7893 20.0391 21.4142 20.4142C21.0391 20.7893 20.5304 21 20 21H4C3.46957 21 2.96086 20.7893 2.58579 20.4142C2.21071 20.0391 2 19.5304 2 19V5C2 4.46957 2.21071 3.96086 2.58579 3.58579C2.96086 3.21071 3.46957 3 4 3H9L11 6H20C20.5304 6 21.0391 6.21071 21.4142 6.58579C21.7893 6.96086 22 7.46957 22 8V19Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        );
      case 'chat':
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        );
      case 'settings':
        return (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.258 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.976 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.0113 9.77251C4.28059 9.5799 4.48572 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        );
      default:
        return null;
    }
  };

  const getStatusClass = (status) => {
    switch (status.toLowerCase()) {
      case 'approved':
        return 'approved';
      case 'pending':
        return 'pending';
      case 'rejected':
        return 'rejected';
      default:
        return '';
    }
  };

  return (
    <div className="specialist-manage-page">
      {/* Header */}
      <header className="specialist-header">
        <div className="header-content">
          <img 
            src="/logo.png?v=2" 
            alt="Conflux" 
            className="logo"
          />
          <div className="header-right">
            <div className="language-selector">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.58333 2.15234C7.93516 2.15234 6.32399 2.64109 4.95358 3.55676C3.58317 4.47244 2.51507 5.77393 1.88434 7.29665C1.25361 8.81936 1.08858 10.4949 1.41013 12.1114C1.73167 13.7279 2.52534 15.2128 3.69078 16.3782C4.85622 17.5437 6.34107 18.3373 7.95758 18.6589C9.57409 18.9804 11.2496 18.8154 12.7724 18.1847C14.2951 17.5539 15.5966 16.4858 16.5122 15.1154C17.4279 13.745 17.9167 12.1339 17.9167 10.4857C17.9141 8.27632 17.0353 6.15818 15.4731 4.59593C13.9108 3.03368 11.7927 2.15489 9.58333 2.15234Z" fill="#354556"/>
              </svg>
              <span>عربي</span>
            </div>
            <div className="user-profile">
              <div className="user-avatar">
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20Z" fill="#1F396C"/>
                  <text x="50%" y="55%" dominantBaseline="middle" textAnchor="middle" fill="white" fontSize="16" fontWeight="500">A</text>
                </svg>
              </div>
              <div className="user-info">
                <span className="company-name">Admin Panel</span>
                <div className="user-role">
                  <span>Administrator</span>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 6.33398L8 10.334L4 6.33398H12Z" fill="#6D6D6D" stroke="#6D6D6D" strokeWidth="2" strokeLinejoin="round"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="specialist-container">
        {/* Sidebar */}
        <aside className="specialist-sidebar">
          <div className="sidebar-profile">
            <div className="admin-avatar">
              <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="60" cy="60" r="60" fill="#1F396C"/>
                <text x="50%" y="55%" dominantBaseline="middle" textAnchor="middle" fill="white" fontSize="48" fontWeight="500">A</text>
              </svg>
            </div>
          </div>
          <nav className="sidebar-nav">
            {sidebarMenuItems.map((item) => (
              <div key={item.id} className={`nav-item ${item.active ? 'active' : ''}`}>
                <div className="nav-item-content">
                  {renderIcon(item.icon)}
                  <span>{item.label}</span>
                </div>
                {item.hasSubmenu && (
                  <svg className="chevron-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 6L15 12L9 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                )}
              </div>
            ))}
            <div className="nav-item logout">
              <div className="nav-item-content">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.5 3.751C5.974 3.751 5.25 4.381 5.25 5.572V18.431C5.25 19.623 5.974 20.252 6.5 20.252H13.496C13.6949 20.252 13.8857 20.331 14.0263 20.4717C14.167 20.6123 14.246 20.8031 14.246 21.002C14.246 21.2009 14.167 21.3917 14.0263 21.5323C13.8857 21.673 13.6949 21.752 13.496 21.752H6.5C4.817 21.752 3.75 20.079 3.75 18.431V5.571C3.75 3.923 4.817 2.25 6.5 2.25H13.5C13.6989 2.25 13.8897 2.32902 14.0303 2.46967C14.171 2.61032 14.25 2.80109 14.25 3C14.25 3.19891 14.171 3.38968 14.0303 3.53033C13.8897 3.67098 13.6989 3.75 13.5 3.75L6.5 3.751Z" fill="#FF7474"/>
                  <path d="M16.53 7.97325C16.3894 7.8328 16.1988 7.75391 16 7.75391C15.8012 7.75391 15.6106 7.8328 15.47 7.97325V11.2492H9.5C9.30109 11.2492 9.11032 11.3283 8.96967 11.4689C8.82902 11.6096 8.75 11.8003 8.75 11.9992C8.75 12.1982 8.82902 12.3889 8.96967 12.5296C9.11032 12.6702 9.30109 12.7492 9.5 12.7492H15.47V16.0332C15.6106 16.1737 15.8012 16.2526 16 16.2526C16.1988 16.2526 16.3894 16.1737 16.53 16.0332L20.03 12.5332C20.0999 12.4634 20.1553 12.3805 20.1931 12.2892C20.2308 12.1979 20.2502 12.1 20.25 12.0012V11.9992C20.2499 11.8896 20.2258 11.7812 20.1793 11.6819C20.1329 11.5825 20.0652 11.4946 19.981 11.4242L16.53 7.97325Z" fill="#FF7474"/>
                </svg>
                <span>Logout</span>
              </div>
            </div>
          </nav>
        </aside>

        {/* Main Content */}
        <main className="specialist-main">
          <div className="page-header">
            <div className="page-title-section">
              <h1 className="page-title">Specialists Manage</h1>
              <p className="page-description">
                Review, Approve, and Manage Specialist Accounts in One Place
              </p>
            </div>
          </div>

          <div className="specialist-list-section">
            <div className="list-header">
              <h2 className="list-title">Specialists List</h2>
              <div className="list-controls">
                <div className="search-box">
                  <input 
                    type="text" 
                    placeholder="Search specialists..." 
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.167 14.167L17.5003 17.5003" stroke="#969696" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667Z" stroke="#969696" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className="dropdown category-dropdown">
                  <span>{categoryFilter}</span>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 7.5L10 12.5L15 7.5" stroke="#6D6D6D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className="dropdown status-dropdown">
                  <span>{statusFilter}</span>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 7.5L10 12.5L15 7.5" stroke="#6D6D6D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </div>
            </div>

            <div className="specialist-table">
              <div className="table-header">
                <div className="col-checkbox">
                  <input 
                    type="checkbox" 
                    checked={selectedSpecialists.length === specialistData.length}
                    onChange={handleSelectAll}
                  />
                  <span>All</span>
                </div>
                <div className="col-date">Date</div>
                <div className="col-name">Name</div>
                <div className="col-title">Title</div>
                <div className="col-category">Category</div>
                <div className="col-location">Location</div>
                <div className="col-email">Email</div>
                <div className="col-status">Status</div>
                <div className="col-action">Action</div>
              </div>

              <div className="table-body">
                {specialistData.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE).map((specialist) => (
                  <div key={specialist.id} className="table-row">
                    <div className="col-checkbox">
                      <input 
                        type="checkbox" 
                        checked={selectedSpecialists.includes(specialist.id)}
                        onChange={() => handleSelectSpecialist(specialist.id)}
                      />
                    </div>
                    <div className="col-date">{specialist.date}</div>
                    <div className="col-name">
                      <div className="specialist-name-cell">
                        <img 
                          src={specialist.avatar} 
                          alt={specialist.name}
                          className="specialist-avatar-small"
                        />
                        <span>{specialist.name}</span>
                      </div>
                    </div>
                    <div className="col-title">{specialist.title}</div>
                    <div className="col-category">{specialist.category}</div>
                    <div className="col-location">{specialist.location}</div>
                    <div className="col-email">{specialist.email}</div>
                    <div className="col-status">
                      <span className={`status-badge ${getStatusClass(specialist.status)}`}>
                        {specialist.status}
                      </span>
                    </div>
                    <div className="col-action">
                      <button 
                        className="details-btn"
                        onClick={() => handleViewDetails(specialist)}
                      >
                        Details
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <Pagination currentPage={currentPage} totalPages={Math.ceil(specialistData.length / ITEMS_PER_PAGE)} onPageChange={setCurrentPage} />
          </div>
        </main>
      </div>

      {/* Specialist Account Modal */}
      <SpecialistAccountModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        specialist={selectedSpecialist}
        onApprove={handleApprove}
        onCancel={handleCloseModal}
      />
    </div>
  );
};

export default SpecialistManagePage;
